/* gk-sizechart */
if (!customElements.get('gk-sizechart')) {
  class GkSizechart extends HTMLElement {
    connectedCallback() {
      this.addTreinoTab();
      this.drawer = this.querySelector('[data-gk-sc-drawer]');
      this.openBtn = this.querySelector('[data-gk-sc-open]');
      this.closeBtns = this.querySelectorAll('[data-gk-sc-close]');
      this.tabs = Array.from(this.querySelectorAll('[data-gk-sc-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gk-sc-panel]'));

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
      this.closeBtns.forEach((el) => el.addEventListener('click', () => this.close()));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.switchTab(tab.dataset.gkScTab)));

      // Em fatos de treino e casacos, abre logo no separador certo
      if (this.isTreinoProduct()) this.switchTab('treino');

      this.escHandler = (e) => { if (e.key === 'Escape') this.close(); };

      // Textos do guia de medidas em "tu" (o texto vem fixo do tema)
      this.fixGuideText();

      // "Tabela de medidas" ao lado do título "Tamanho" (volta a pôr-se sozinho se o seletor de tamanhos for redesenhado)
      this.placeInline();
      const scope = this.closest('.product__info-container') || this.parentElement;
      if (scope && window.MutationObserver && !this.observer) {
        this.observer = new MutationObserver(() => this.placeInline());
        this.observer.observe(scope, { childList: true, subtree: true });
      }
    }

    fixGuideText() {
      const map = [
        [/Como tirar suas medidas:?/i, 'Como tirar as tuas medidas:'],
        [/^Posicione a fita métrica na costura superior do ombro.*$/i, 'Coloca a fita métrica na costura de cima do ombro, onde a manga se junta ao corpo, e estica-a até à bainha da camisola.'],
        [/^Meça a distância de uma axila à outra.*$/i, 'Mede a distância de uma axila à outra, na parte da frente da camisola.'],
        [/^Posicione a fita métrica no pé.*$/i, 'Mede com a fita métrica desde os pés até ao topo da cabeça.'],
      ];
      const root = this.drawer || this;
      root.querySelectorAll('.gk-sc__guide-title, .gk-sc__step-desc').forEach((el) => {
        const t = el.textContent.trim();
        for (const [re, txt] of map) {
          if (re.test(t)) { el.textContent = txt; break; }
        }
      });
      const guide = root.querySelector('.gk-sc__guide');
      if (guide) guide.setAttribute('aria-label', 'Como tirar as tuas medidas');
    }

    findSizeLegend() {
      const scope = this.closest('.product__info-container') || this.parentElement;
      if (!scope) return null;
      const legends = Array.from(scope.querySelectorAll('variant-selects legend.form__label'));
      if (!legends.length) return null;
      return legends.find((l) => /tamanho|size|taille|talla/i.test(l.textContent)) || legends[0];
    }

    placeInline() {
      if (!this.openBtn) return;
      const legend = this.findSizeLegend();
      if (!legend) {
        // sem seletor de tamanhos: a linha original continua no sítio
        if (!this.contains(this.openBtn)) this.prepend(this.openBtn);
        this.classList.remove('gk-sc--inline');
        return;
      }
      if (legend.contains(this.openBtn)) return;
      legend.classList.add('gk-sc-legend');
      legend.appendChild(this.openBtn);
      this.classList.add('gk-sc--inline');
    }

    // --- Separador "Fato de treino / Casaco" (tabela + desenho explicativo) ---
    addTreinoTab() {
      if (this.querySelector('[data-gk-sc-tab="treino"]')) return;
      const firstTab = this.querySelector('[data-gk-sc-tab]');
      const firstPanel = this.querySelector('[data-gk-sc-panel]');
      if (!firstTab || !firstPanel) return;

      const tab = firstTab.cloneNode(false);
      tab.classList.remove('is-active');
      tab.dataset.gkScTab = 'treino';
      tab.setAttribute('aria-selected', 'false');
      tab.removeAttribute('id');
      tab.textContent = 'Fato de treino / Casaco';
      firstTab.parentNode.appendChild(tab);

      const rows = [['S', 69, 100, 99], ['M', 71, 104, 101], ['L', 73, 108, 104], ['XL', 75, 112, 106], ['2XL', 77, 116, 109]];
      const C = '#1d5cff';
      const num = (x, y, n) => `<circle cx="${x}" cy="${y}" r="11" fill="${C}"/><text x="${x}" y="${y + 4.5}" text-anchor="middle" font-size="13" font-weight="800" fill="#fff" font-family="Arial,sans-serif">${n}</text>`;
      const svg = `
<svg viewBox="0 0 400 236" width="100%" role="img" aria-label="Como medir o casaco e a calça do fato de treino" xmlns="http://www.w3.org/2000/svg" style="max-width:420px;display:block;margin:0 auto">
  <defs><marker id="gkscTrArr" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0L10 5L0 10z" fill="${C}"/></marker></defs>
  <g fill="#fff" stroke="#555" stroke-width="2.4" stroke-linejoin="round">
    <path d="M70 40L92 30Q110 38 128 30L150 40L185 52Q200 60 202 80L212 190L192 194L180 95L178 200L42 200L40 95L28 194L8 190L18 80Q20 60 35 52Z"/>
    <path d="M92 30L92 20L128 20L128 30" fill="none"/>
    <path d="M255 18L345 18L352 202L310 204L300 72L290 204L248 202Z"/>
  </g>
  <g fill="none" stroke="#555" stroke-width="1.6">
    <path d="M110 22V100"/><path d="M42 186H178" stroke-dasharray="3 3"/>
    <path d="M253 32H347"/>
  </g>
  <g stroke="${C}" stroke-width="2.4" stroke-dasharray="6 4" fill="none">
    <path d="M148 22V196" marker-start="url(#gkscTrArr)" marker-end="url(#gkscTrArr)"/>
    <path d="M46 118H174" marker-start="url(#gkscTrArr)" marker-end="url(#gkscTrArr)"/>
    <path d="M372 18V202" marker-start="url(#gkscTrArr)" marker-end="url(#gkscTrArr)"/>
  </g>
  ${num(162, 70, 1)}${num(72, 118, 2)}${num(372, 110, 3)}
  <g font-family="Arial,sans-serif" font-size="12" font-weight="700" fill="#0f172a" text-anchor="middle">
    <text x="110" y="224">Casaco</text><text x="300" y="224">Calça</text>
  </g>
</svg>`;

      const panel = firstPanel.cloneNode(false);
      panel.classList.remove('is-active');
      panel.dataset.gkScPanel = 'treino';
      panel.setAttribute('hidden', '');
      panel.removeAttribute('id');
      panel.innerHTML = `
<h3 class="gk-sc__chart-title">Fato de treino · Casaco</h3>
<p class="gk-sc__subtitle">Medidas em cm</p>
<table class="gk-sc__table">
  <thead><tr><th>Tam</th><th>Comp.</th><th>Busto</th><th>Calça</th></tr></thead>
  <tbody>${rows.map((r) => `<tr><td>${r[0]}</td><td>${r[1]}</td><td>${r[2]}</td><td>${r[3]}</td></tr>`).join('')}</tbody>
</table>
<p class="gk-sc__note">*Devido à produção manual, as medidas são aproximadas (margem de 1–3 cm).</p>
<div class="gk-sc__guide" aria-label="Como medir o fato de treino">
  <h4 class="gk-sc__guide-title">Como medir o fato de treino:</h4>
  <p class="gk-sc__guide-intro">Pega num casaco ou fato de treino que já tenhas e que te sirva bem, estica-o numa mesa e compara com a tabela.</p>
  <div class="gk-sc__guide-figure">${svg}</div>
  <ol class="gk-sc__guide-steps">
    <li><span class="gk-sc__step-num">1</span><div><p class="gk-sc__step-title">Comprimento (casaco)</p><p class="gk-sc__step-desc">Mede desde o topo da gola até à bainha, o fundo do casaco.</p></div></li>
    <li><span class="gk-sc__step-num">2</span><div><p class="gk-sc__step-title">Busto (casaco)</p><p class="gk-sc__step-desc">É a volta completa ao peito, por baixo das axilas. Com o casaco esticado, mede de uma axila à outra e multiplica por 2.</p></div></li>
    <li><span class="gk-sc__step-num">3</span><div><p class="gk-sc__step-title">Calça</p><p class="gk-sc__step-desc">Mede o comprimento da calça desde o cós (a cintura) até ao fundo da perna.</p></div></li>
  </ol>
  <p class="gk-sc__warning">💡 Se estiveres entre dois tamanhos, escolhe o maior.</p>
</div>`;
      firstPanel.parentNode.appendChild(panel);
    }

    isTreinoProduct() {
      const h = document.querySelector('.product__title h1, .product__title, h1');
      const og = document.querySelector('meta[property="og:title"]');
      const t = `${h ? h.textContent : ''} ${og ? og.content : ''}`;
      return /fato\s+de\s+treino|casaco|corta[\s-]?vento|blus[aã]o|jaqueta|anorak|track\s?suit/i.test(t);
    }

    open() {
      if (!this.drawer) return;
      // Move o drawer pro body pra evitar z-index issues
      if (this.drawer.parentNode !== document.body) {
        document.body.appendChild(this.drawer);
      }
      this.drawer.removeAttribute('hidden');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.escHandler);
    }

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      setTimeout(() => {
        this.drawer.setAttribute('hidden', '');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.escHandler);
      }, 320);
    }

    switchTab(id) {
      this.tabs.forEach((t) => {
        const active = t.dataset.gkScTab === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      // O guia das camisolas (boneco) não aparece no separador do fato de treino, que tem o seu próprio desenho
      const root = this.drawer || this;
      root.querySelectorAll('.gk-sc__guide').forEach((g) => {
        if (!g.closest('[data-gk-sc-panel="treino"]')) g.style.display = id === 'treino' ? 'none' : '';
      });
      this.panels.forEach((p) => {
        const active = p.dataset.gkScPanel === id;
        p.classList.toggle('is-active', active);
        if (active) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }
  }
  customElements.define('gk-sizechart', GkSizechart);
}
